import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { AddbrandComponent } from '../../brand/addbrand/addbrand.component';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { AddfoodsymbolComponent } from '../../foodsymbol/addfoodsymbol/addfoodsymbol.component';
import { AddgroupComponent } from '../../group/addgroup/addgroup.component';
import { AddsubgroupComponent } from '../../subgroup/addsubgroup/addsubgroup.component';
import { AddtaxComponent } from '../../tax/addtax/addtax.component';
import { AdduomComponent } from '../../uom/adduom/adduom.component';
import { ProductvariationComponent } from '../productvariation/productvariation.component';

@Component({
  selector: 'app-addproduct',
  templateUrl: './addproduct.component.html',
  styleUrls: ['./addproduct.component.css']
})
export class AddproductComponent implements OnInit {


  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isgroupaddmode: boolean = false;
  issubgroupaddmode: boolean = false;
  isuomaddmode: boolean = false;
  isbrandaddmode: boolean = false;
  isfoodsymboladdmode: boolean = false;
  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  errtxt: any = "";

  productvariationColl: any = [];
  productBO: any = [];
  //Edit Get Values
  productColl: any = [];
  companyColl: any = [];
  groupColl: any = [];
  subgroupColl: any = [];
  taxColl: any = [];
  brandColl: any = [];
  uomColl: any = [];
  foodsymbolColl: any = [];
  pricetypeColl: any = [];

  ischeckall: boolean = false;
  //pageColl:any=[];

  productform = new FormGroup({
    productid: new FormControl(0),
    productcode: new FormControl('', Validators.required),
    productname: new FormControl('', Validators.required),
    productdesc: new FormControl(null),
    barcode: new FormControl(''),
    groupid: new FormControl(null, Validators.required),
    subgroupid: new FormControl(null),
    brandid: new FormControl(null),
    uomid: new FormControl(null),
    taxid: new FormControl(null, Validators.required),
    foodsymbolid: new FormControl(null, Validators.required),
    istaxincluded: new FormControl(false),
    price1: new FormControl(null, Validators.required),
    cost: new FormControl(null),
    sp1: new FormControl(null),
    sp2: new FormControl(null),
    sp3: new FormControl(null),
    sp4: new FormControl(null),
    sp5: new FormControl(null),
    sp6: new FormControl(null),
    sp7: new FormControl(null),
    sp8: new FormControl(null),
    sp9: new FormControl(null),
    sp10: new FormControl(null),
    isdinein: new FormControl(false),
    istakeaway: new FormControl(false),
    isdelivery: new FormControl(false),
    isonline: new FormControl(false),
    issunday: new FormControl(false),
    ismonday: new FormControl(false),
    istuesday: new FormControl(false),
    iswednesday: new FormControl(false),
    isthursday: new FormControl(false),
    isfriday: new FormControl(false),
    issaturday: new FormControl(false),
    picurl: new FormControl(''),
    logoimage: new FormControl(null),
    isfavourite: new FormControl(false),
    isvariation: new FormControl(false),
    isoutofstock: new FormControl(false),
    istaxincludedsp1: new FormControl(false),
    istaxincludedsp2: new FormControl(false),
    istaxincludedsp3: new FormControl(false),
    istaxincludedsp4: new FormControl(false),
    istaxincludedsp5: new FormControl(false),
    istaxincludedsp6: new FormControl(false),
    istaxincludedsp7: new FormControl(false),
    istaxincludedsp8: new FormControl(false),
    istaxincludedsp9: new FormControl(false),
    istaxincludedsp10: new FormControl(false),
    sp1taxid: new FormControl(null),
    sp2taxid: new FormControl(null),
    sp3taxid: new FormControl(null),
    sp4taxid: new FormControl(null),
    sp5taxid: new FormControl(null),
    sp6taxid: new FormControl(null),
    sp7taxid: new FormControl(null),
    sp8taxid: new FormControl(null),
    sp9taxid: new FormControl(null),
    sp10taxid: new FormControl(null),
    productsectionorderno: new FormControl(null),
    productnamelan: new FormControl(null),
    inactive: new FormControl(false),
    //price: new FormControl(null, Validators.min(1)),
    // productimage: new FormControl(null),

  });


  //set image
  image;
  strImage: any;
  picurl: string = "";
  picname: string = "";

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Product";

  @Input() productid: number = 0
  @Output() emitData = new EventEmitter();

  issp1: boolean = false;
  issp2: boolean = false;
  issp3: boolean = false;
  issp4: boolean = false;
  issp5: boolean = false;
  issp6: boolean = false;
  issp7: boolean = false;
  issp8: boolean = false;
  issp9: boolean = false;
  issp10: boolean = false;


  sp1displayname: string = '';
  sp2displayname: string = '';
  sp3displayname: string = '';
  sp4displayname: string = '';
  sp5displayname: string = '';
  sp6displayname: string = '';
  sp7displayname: string = '';
  sp8displayname: string = '';
  sp9displayname: string = '';
  sp10displayname: string = '';

  currencyMask: any = "";

  constructor(private appService: DhukanDataService, private confirmationDialogService: ConfirmationDialogService, private productFindService: NgbModal, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService, private activeModal: NgbActiveModal,) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.productid = params.id
      }
    });
    this.fnServiceChanges();

    this.currencyMask = this.loginService.fngetDecimalPlaces()


  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }

      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.productform.reset();
      this.fnInitializeProduct();

      if (this.productid > 0) {
        this.fngetProduct();
      }
      else {
        if (this.loginService.fnCheckCompanysettings("ENABLE_AUTOCODE_PRODUCT") === "Yes") {
          this.fngetProductAutoCode()
        }
      }

      this.fngetGroup()
      this.fngetSubgroup()
      this.fngetBrand()
      this.fngetUom()
      this.fngetTax()
      this.fngetCompany()
      this.fngetFoodsymbol()
      this.fngetPricetype()


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.productid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    this.isgroupaddmode = this.loginService.fnCheckUserRoleAction("Group", 'CREATE')
    this.issubgroupaddmode = this.loginService.fnCheckUserRoleAction("Subgroup", 'CREATE')
    this.isuomaddmode = this.loginService.fnCheckUserRoleAction("Uom", 'CREATE')
    this.isbrandaddmode = this.loginService.fnCheckUserRoleAction("Brand", 'CREATE')
    this.isfoodsymboladdmode = this.loginService.fnCheckUserRoleAction("Foodsymbol", 'CREATE')


    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeProduct() {
    this.productform.setValue({
      productid: 0,
      productname: '',
      productcode: '',
      barcode: '',
      productdesc: '',
      groupid: null,
      subgroupid: null,
      brandid: null,
      uomid: null,
      taxid: null,
      istaxincluded: false,
      price1: null,
      cost: null,
      sp1: null,
      sp2: null,
      sp3: null,
      sp4: null,
      sp5: null,
      sp6: null,
      sp7: null,
      sp8: null,
      sp9: null,
      sp10: null,
      foodsymbolid: null,
      isdinein: true,
      istakeaway: true,
      isdelivery: true,
      isonline: true,
      issunday: false,
      ismonday: false,
      istuesday: false,
      iswednesday: false,
      isthursday: false,
      isfriday: null,
      issaturday: false,
      picurl: '',
      logoimage: null,
      isfavourite: false,
      isvariation: false,
      isoutofstock: false,
      istaxincludedsp1: false,
      istaxincludedsp2: false,
      istaxincludedsp3: false,
      istaxincludedsp4: false,
      istaxincludedsp5: false,
      istaxincludedsp6: false,
      istaxincludedsp7: false,
      istaxincludedsp8: false,
      istaxincludedsp9: false,
      istaxincludedsp10: false,
      sp1taxid: null,
      sp2taxid: null,
      sp3taxid: null,
      sp4taxid: null,
      sp5taxid: null,
      sp6taxid: null,
      sp7taxid: null,
      sp8taxid: null,
      sp9taxid: null,
      sp10taxid: null,
      productsectionorderno: null,
      productnamelan: null,
      inactive: false,

    })
  }
  fngetPricetype() {
    var data = {
      'pricetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),

    }
    this.appService.getPricetype(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.pricetypeColl = res.json().result;
            ////console.log(this.pricetypeColl)


            for (let abo of this.pricetypeColl) {
              if (abo.pricetag === 'SP1') {
                this.issp1 = true
                this.sp1displayname = abo.pricetypename
              }
              else if (abo.pricetag === 'SP2') {
                this.issp2 = true
                this.sp2displayname = abo.pricetypename
              }
              else if (abo.pricetag === 'SP3') {
                this.issp3 = true
                this.sp3displayname = abo.pricetypename
              }
              else if (abo.pricetag === 'SP4') {
                this.issp4 = true
                this.sp4displayname = abo.pricetypename
              }
              else if (abo.pricetag === 'SP5') {
                this.issp5 = true
                this.sp5displayname = abo.pricetypename
              }
              else if (abo.pricetag === 'SP6') {
                this.issp6 = true
                this.sp6displayname = abo.pricetypename
              } else if (abo.pricetag === 'SP7') {
                this.issp7 = true
                this.sp7displayname = abo.pricetypename
              } else if (abo.pricetag === 'SP8') {
                this.issp8 = true
                this.sp8displayname = abo.pricetypename
              } else if (abo.pricetag === 'SP9') {
                this.issp9 = true
                this.sp9displayname = abo.pricetypename
              } else if (abo.pricetag === 'SP10') {
                this.issp10 = true
                this.sp10displayname = abo.pricetypename
              }
            }

          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetFoodsymbol() {
    var data = {
      'foodsymbolid': 0,
      'companyid': this.loginService.fnGetCompanyId(),

    }
    this.appService.getFoodsymbol(data)
      .subscribe(
        (res) => {
          this.foodsymbolColl = res.json().result;

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  //Get 
  fngetCompany() {
    var data = {
      'companyid': 0,

    }
    this.appService.getCompany(data)
      .subscribe(
        (res) => {
          this.companyColl = res.json().result;

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  //Get 
  fngetGroup() {
    var data = {
      'groupid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getGroup(data)
      .subscribe(
        (res) => {
          this.groupColl = res.json().result;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  //Get 
  fngetTax() {
    var data = {
      'taxid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getTax(data)
      .subscribe(
        (res) => {
          this.taxColl = res.json().result;
          //  this.fnsetTaxtype()
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  //Get 
  fngetBrand() {
    var data = {
      'brandid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getBrand(data)
      .subscribe(
        (res) => {
          this.brandColl = res.json().result;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Get 
  fngetUom() {
    var data = {
      'uomid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getUom(data)
      .subscribe(
        (res) => {
          this.uomColl = res.json().result;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetSubgroup() {

    if (this.productform.get('groupid').value > 0) {

      var data = {
        'groupid': this.productform.get('groupid').value,
        'organizationid': this.loginService.fnGetOrganizationId(),
      }
      this.appService.getSubgroup(data)
        .subscribe(
          (res) => {
            this.subgroupColl = res.json().result;

            // if (this.subgroupColl.length > 0) {
            //   let ischeck = false;
            //   for (let lbo of this.subgroupColl) {
            //     if (lbo.subgroupid === this.productform.get('subgroupid').value) {
            //       ischeck = true;
            //     }
            //   }

            //   if (ischeck === false) {
            //     this.productform.patchValue({ subgroupid: null });
            //   }

            // }

          },
          (err) => {
            this.toastr.error('Error', err);
          })
    }
    else {
      // this.subgroupColl = []
      // this.productform.patchValue({ subgroupid: null });
    }

  }


  fnGroupChange() {
    // let groupid = this.productform.get('groupid').value;
    // if (groupid === null) {
    //   this.productform.patchValue({ subgroupid: null });
    // }

  }

  fngetProductAutoCode() {
    var data = {
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.fnGetProductAutoCode(data)
      .subscribe(
        (res) => {
          var result = res.json().result
          if (result.length > 0) {
            var productcode = result[0].productcode;
            this.productform.patchValue({ 'productcode': productcode })
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetProduct() {
    var data = {
      'productid': this.productid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getProduct(data)
      .subscribe(
        (res) => {

          this.productColl = res.json().result[0];
          this.productvariationColl = res.json().result[1];
          //console.log(this.productvariationColl)

          var editdata = this.productColl[0];
          this.productBO = editdata
          this.fnEditMode(editdata);

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  // fnValidation() {

  //   var _ischeck = false;
  //   var _detailscheck = false;

  //   for (let row of this.productColl) {

  //     if (row.taxid > 0) {
  //       _detailscheck = true;
  //     }

  //   }
  //   if (!_detailscheck) {
  //     this.errtxt = "Select Tax Percentage"
  //     this.productform.controls['inactive'].setErrors({ 'notfound': true });
  //     _ischeck = true;
  //   }
  // }
  // fnResetValidation() {

  //   if (this.productform.get('inactive')) {
  //     this.productform.controls['inactive'].setErrors(null);
  //   }

  // }
  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return
      }
      this.submitted = true;
      this.successfully = false;

      //  this.fnResetValidation()
      //Validate
      if (this.productform.valid) {
        this.saveloading = true
        //  this.fnValidation()
        //Check
        var data = {
          'productid': this.productid,
          'productcode': this.productform.get('productcode').value,
          'productname': this.productform.get('productname').value,
          'barcode': this.productform.get('barcode').value,
          'productdesc': this.productform.get('productdesc').value,
          'groupid': this.productform.get('groupid').value,
          'subgroupid': this.productform.get('subgroupid').value,
          'brandid': this.productform.get('brandid').value,
          'uomid': this.productform.get('uomid').value,
          'taxid': this.productform.get('taxid').value,
          'istaxincluded': this.productform.get('istaxincluded').value,
          'price1': this.productform.get('price1').value,
          'cost': this.productform.get('cost').value,
          'sp1': this.productform.get('sp1').value,
          'sp2': this.productform.get('sp2').value,
          'sp3': this.productform.get('sp3').value,
          'sp4': this.productform.get('sp4').value,
          'sp5': this.productform.get('sp5').value,
          'sp6': this.productform.get('sp6').value,
          'sp7': this.productform.get('sp7').value,
          'sp8': this.productform.get('sp8').value,
          'sp9': this.productform.get('sp9').value,
          'sp10': this.productform.get('sp10').value,
          'foodsymbolid': this.productform.get('foodsymbolid').value,
          'isdinein': this.productform.get('isdinein').value,
          'istakeaway': this.productform.get('istakeaway').value,
          'isdelivery': this.productform.get('isdelivery').value,
          'isonline': this.productform.get('isonline').value,
          'issunday': this.productform.get('issunday').value,
          'ismonday': this.productform.get('ismonday').value,
          'istuesday': this.productform.get('istuesday').value,
          'iswednesday': this.productform.get('iswednesday').value,
          'isthursday': this.productform.get('isthursday').value,
          'isfriday': this.productform.get('isfriday').value,
          'issaturday': this.productform.get('issaturday').value,
          'logoimage': this.strImage,
          'picurl': this.picurl,
          'isfavourite': this.productform.get('isfavourite').value,
          'isoutofstock': this.productform.get('isoutofstock').value,
          'isvariation': this.productform.get('isvariation').value,

          'istaxincludedsp1': this.productform.get('istaxincludedsp1').value,
          'istaxincludedsp2': this.productform.get('istaxincludedsp2').value,
          'istaxincludedsp3': this.productform.get('istaxincludedsp3').value,
          'istaxincludedsp4': this.productform.get('istaxincludedsp4').value,
          'istaxincludedsp5': this.productform.get('istaxincludedsp5').value,
          'istaxincludedsp6': this.productform.get('istaxincludedsp6').value,
          'istaxincludedsp7': this.productform.get('istaxincludedsp7').value,
          'istaxincludedsp8': this.productform.get('istaxincludedsp8').value,
          'istaxincludedsp9': this.productform.get('istaxincludedsp9').value,
          'istaxincludedsp10': this.productform.get('istaxincludedsp10').value,

          'sp1taxid': this.productform.get('sp1taxid').value,
          'sp2taxid': this.productform.get('sp2taxid').value,
          'sp3taxid': this.productform.get('sp3taxid').value,
          'sp4taxid': this.productform.get('sp4taxid').value,
          'sp5taxid': this.productform.get('sp5taxid').value,
          'sp6taxid': this.productform.get('sp6taxid').value,
          'sp7taxid': this.productform.get('sp7taxid').value,
          'sp8taxid': this.productform.get('sp8taxid').value,
          'sp9taxid': this.productform.get('sp9taxid').value,
          'sp10taxid': this.productform.get('sp10taxid').value,
          'productsectionorderno': this.productform.get('productsectionorderno').value,

          'productnamelan': this.productform.get('productnamelan').value,

          'inactive': this.productform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'organizationid': this.loginService.fnGetOrganizationId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckProduct(data).subscribe(
          (res) => {
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.productform.get('productid').value > 0) {
                //Update Department
                this.fnSetProduct(data);
              }
              else {
                //Insert Department
                this.fnInsertProduct(data);
              }
            }
            else {

              if (_checkresult === "name") {
                this.saveloading = false
                this.productform.controls['productname'].setErrors({ 'notfound': true });
              } else if (_checkresult === "code") {

                this.saveloading = false
                this.productform.controls['productcode'].setErrors({ 'notfound': true });
              }

            }
          },
          (err) => {
            this.saveloading = false

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertProduct(data) {

    this.appService.fnInsertProduct(data).subscribe(
      (res) => {
        this.saveloading = false
        console.log(res.json())
        if (res.json().status === 200) {
          this.toastr.success('', "The new Product has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.productname);

          this.emitData.emit(this.productid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetProduct(data) {

    this.appService.fnSetProduct(data).subscribe(
      (res) => {
        this.saveloading = false

        console.log(res.json())
        if (res.json().status === 200) {
          this.toastr.success('', "The Product has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.productid, data.productname);

          this.emitData.emit(this.productid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false

        this.toastr.error('Error', err);
      });

  }

  //Close

  //Close
  public decline() {
    this.activeModal.close(false);
  }

  // fnsetTaxtype() {
  //   var _taxtype = '';
  //   for (let row of this.companyColl) {
  //     _taxtype = row.taxtype
  //   }

  //   this.productform.patchValue({ 'taxid': _taxtype })

  // }


  //Image Import
  changeListener($event): void {
    try {
      this.readThis($event.target);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  readThis(inputValue: any): void {

    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.image = myReader.result;
      this.strImage = this.image.split(',')[1];
    }
    myReader.readAsDataURL(file);
  }

  removeimage() {
    this.image = null;
    this.strImage = null;
    this.picurl = "";
  }

  fnOpenFileBrowser(event: any) {

    event.preventDefault();

    let element: HTMLElement = document.getElementById('image') as HTMLElement;
    element.click();

  }





  private fnEditMode(deptBO) {

    console.log(deptBO)

    this.productform.setValue({
      productid: deptBO.productid,
      productcode: deptBO.productcode,
      productname: deptBO.productname,
      barcode: deptBO.barcode,
      productdesc: deptBO.productdesc,
      groupid: deptBO.groupid,
      subgroupid: deptBO.subgroupid,
      brandid: deptBO.brandid,
      uomid: deptBO.uomid,
      taxid: deptBO.taxid,
      istaxincluded: deptBO.istaxincluded,
      price1: deptBO.price1,
      cost: deptBO.cost,
      sp1: deptBO.sp1,
      sp2: deptBO.sp2,
      sp3: deptBO.sp3,
      sp4: deptBO.sp4,
      sp5: deptBO.sp5,
      sp6: deptBO.sp6,
      sp7: deptBO.sp7,
      sp8: deptBO.sp8,
      sp9: deptBO.sp9,
      sp10: deptBO.sp10,
      foodsymbolid: deptBO.foodsymbolid,
      isdinein: deptBO.isdinein,
      istakeaway: deptBO.istakeaway,
      isdelivery: deptBO.isdelivery,
      isonline: deptBO.isonline,
      issunday: deptBO.issunday,
      ismonday: deptBO.ismonday,
      istuesday: deptBO.istuesday,
      iswednesday: deptBO.iswednesday,
      isthursday: deptBO.isthursday,
      isfriday: deptBO.isfriday,
      issaturday: deptBO.issaturday,
      picurl: null,
      logoimage: null,
      isfavourite: deptBO.isfavourite,
      isvariation: deptBO.isvariation,
      inactive: deptBO.inactive,
      isoutofstock: deptBO.isoutofstock,

      istaxincludedsp1: deptBO.istaxincludedsp1,
      istaxincludedsp2: deptBO.istaxincludedsp2,
      istaxincludedsp3: deptBO.istaxincludedsp3,
      istaxincludedsp4: deptBO.istaxincludedsp4,
      istaxincludedsp5: deptBO.istaxincludedsp5,
      istaxincludedsp6: deptBO.istaxincludedsp6,
      istaxincludedsp7: deptBO.istaxincludedsp7,
      istaxincludedsp8: deptBO.istaxincludedsp8,
      istaxincludedsp9: deptBO.istaxincludedsp9,
      istaxincludedsp10: deptBO.istaxincludedsp10,

      sp1taxid: deptBO.sp1taxid,
      sp2taxid: deptBO.sp2taxid,
      sp3taxid: deptBO.sp3taxid,
      sp4taxid: deptBO.sp4taxid,
      sp5taxid: deptBO.sp5taxid,
      sp6taxid: deptBO.sp6taxid,
      sp7taxid: deptBO.sp7taxid,
      sp8taxid: deptBO.sp8taxid,
      sp9taxid: deptBO.sp9taxid,
      sp10taxid: deptBO.sp10taxid,
      productsectionorderno: deptBO.productsectionorderno,

      productnamelan: deptBO.productnamelan,
      // productimage: null,

    });



    // alert( deptBO.picurl)

    this.picurl = deptBO.picurl;

    this.image = null;

    this.fngetSubgroup()

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }

  //Addgroup
  private fnAddGroup() {

    const modalRef = this.productFindService.open(AddgroupComponent, { size: <any>'m' });
    modalRef.componentInstance.groupColl = this.groupColl
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetGroup();

      if (receivedEntry > 0) {
        this.productform.patchValue({ groupid: receivedEntry })
      }
    });

  }
  //AddSubgroup
  private fnAddSubgroup() {

    const modalRef = this.productFindService.open(AddsubgroupComponent, { size: <any>'m' });
    modalRef.componentInstance.subgroupColl = this.subgroupColl
    modalRef.componentInstance.groupid = this.productform.get('groupid').value
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetSubgroup();

      if (receivedEntry > 0) {
        this.productform.patchValue({ subgroupid: receivedEntry })
      }
    });

  }
  private fnAddBrand() {

    const modalRef = this.productFindService.open(AddbrandComponent, { size: <any>'m' });
    modalRef.componentInstance.brandColl = this.brandColl

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetBrand();

      if (receivedEntry > 0) {
        this.productform.patchValue({ brandid: receivedEntry })
      }
    });

  }
  private fnAddFoodsymbol() {

    const modalRef = this.productFindService.open(AddfoodsymbolComponent, { size: <any>'m' });
    modalRef.componentInstance.foodsymbolColl = this.foodsymbolColl
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetFoodsymbol();

      if (receivedEntry > 0) {
        this.productform.patchValue({ foodsymbolid: receivedEntry })
      }
    });

  }
  //AddUom
  private fnAddUom() {

    const modalRef = this.productFindService.open(AdduomComponent, { size: <any>'m' });
    modalRef.componentInstance.uomColl = this.uomColl
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      this.fngetUom();
      if (receivedEntry > 0) {
        this.productform.patchValue({ uomid: receivedEntry })
        //console.log(receivedEntry)
      }


    });

  }

  //Product Variation
  private fnAddProductVariation() {

    const modalRef = this.productFindService.open(ProductvariationComponent, { size: <any>'l' });
    modalRef.componentInstance.productid = this.productid

    modalRef.componentInstance.fnInitializeProductFormGroup();

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      this.fnInsertProductVariation(receivedEntry);
    });

  }


  private fnEditProductVariation(deptBO) {

    const modalRef = this.productFindService.open(ProductvariationComponent, { size: <any>'l' });
    modalRef.componentInstance.productvariationsid = deptBO.productvariationsid
    modalRef.componentInstance.productid = this.productid
    modalRef.componentInstance.sizeid = deptBO.sizeid
    modalRef.componentInstance.variationsname = deptBO.variationsname
    modalRef.componentInstance.uomid = deptBO.uomid
    modalRef.componentInstance.sp1 = deptBO.sp1
    modalRef.componentInstance.sp2 = deptBO.sp2
    modalRef.componentInstance.sp3 = deptBO.sp3
    modalRef.componentInstance.sp4 = deptBO.sp4
    modalRef.componentInstance.sp5 = deptBO.sp5
    modalRef.componentInstance.sp6 = deptBO.sp6
    modalRef.componentInstance.sp7 = deptBO.sp7
    modalRef.componentInstance.sp8 = deptBO.sp8
    modalRef.componentInstance.sp9 = deptBO.sp9
    modalRef.componentInstance.sp10 = deptBO.sp10
    modalRef.componentInstance.uomqty = deptBO.uomqty
    modalRef.componentInstance.price = deptBO.price
    modalRef.componentInstance.cost = deptBO.cost
    modalRef.componentInstance.isoutofstock = deptBO.isoutofstock
    modalRef.componentInstance.inactive = deptBO.inactive

    modalRef.componentInstance.fnInitializeProductFormGroup();

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      this.fnSetProductVariation(receivedEntry);
    });

  }


  public fnDeleteProductVariationConfirm(deptBO) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete Product Variation?')
        .then((confirmed) => {
          if (confirmed) {
            this.fnDeleteProductVariation(deptBO)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  //Insert
  fnInsertProductVariation(data) {

    this.appService.fnInsertProductVariation(data).subscribe(
      (res) => {
        if (res.json().result != "") {
          this.toastr.success('', "The New Product Variation has been added successfully.Insert Successfully");

          // this.fnInsertActivityLog('INSERT', 0, data.productname);
          this.fngetProduct();
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetProductVariation(data) {

    this.appService.fnSetProductVariation(data).subscribe(
      (res) => {
        if (res.json().result != "") {
          this.toastr.success('', "The Product Variation has been updated successfully.");

          //  this.fnInsertActivityLog('EDIT', this.productid, data.productname);

          this.fngetProduct();
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }
  //Delete
  fnDeleteProductVariation(deptBO) {

    var data = {
      productvariationsid: deptBO.productvariationsid,
      modifiedby: this.loginService.fnGetModUserId(),
    }

    this.appService.fnDeleteProductVariation(data).subscribe(
      (res) => {
        if (res.json().result != "") {
          this.toastr.success('', "The Product Variation has been deleted successfully.");

          //  this.fnInsertActivityLog('EDIT', this.productid, data.productname);

          this.fngetProduct();
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    //console.log(ex)
    this.toastr.warning('Internal Error', ex);
  }






}
